function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLivemapFilterLocations = function SvgLivemapFilterLocations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 37.998,
    viewBox: "0 0 38 37.998"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9812"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Location Name 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22044.455-11618.04a42.208 42.208 0 0 1-4.275-4.7c-2.676-3.474-4.027-6.526-4.027-9.086 0-4.428 3.932-8.031 8.779-8.031s8.773 3.6 8.773 8.031c0 6.131-7.965 13.479-8.3 13.787a.72.72 0 0 1-.473.182.719.719 0 0 1-.477-.183zm-6.959-13.787c0 2.081 1.072 4.613 3.184 7.532a40.506 40.506 0 0 0 4.252 4.916 39.624 39.624 0 0 0 4.248-4.916c2.109-2.919 3.178-5.451 3.178-7.532 0-3.743-3.332-6.795-7.426-6.795s-7.432 3.052-7.432 6.795zm7.428 4.48a4.73 4.73 0 0 1-3.221-1.435 4.334 4.334 0 0 1-1.24-3.186 4.38 4.38 0 0 1 1.422-3.083 4.773 4.773 0 0 1 3.328-1.263 4.746 4.746 0 0 1 3.266 1.336 4.36 4.36 0 0 1 1.342 3.149 4.472 4.472 0 0 1-1.447 3.178 4.856 4.856 0 0 1-3.342 1.3zm-3.213-4.38a3.312 3.312 0 0 0 3.383 3.144h.053a3.337 3.337 0 0 0 3.332-3.244 3.388 3.388 0 0 0-3.471-3.238h-.076a3.322 3.322 0 0 0-3.221 3.338z",
    "data-name": "Path 11622",
    style: {
      fill: "#4da5b5"
    },
    transform: "translate(-22026.156 11647.855)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h28v28H0z",
    "data-name": "Rectangle 4499",
    style: {
      fill: "none"
    },
    transform: "translate(5 5)"
  }))));
};
export default SvgLivemapFilterLocations;